import React, { useState, useEffect } from 'react';
import { Alert, Modal, Form, Button, ButtonGroup, Row, Col, Card, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getJobStory, saveJobStory, editJobStory, deleteJobStory } from '../../redux/jobStory/actions';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarConfig from '../../components/SidebarConfig';
import messages from '../../redux/messages';
import CustomTable from '../../components/CustomTable';
import UserMenuComponent from '../../components/profile/UserMenuComponent';

const JobStory = props => {

  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState('');
  
  const columns = [
    {
      Header: 'Código',
      accessor: 'id'
    },
    {
      Header: 'Descripción',
      accessor: 'descripcion'
    },
    // {
    //   Header: 'Empleado',
    //   accessor: 'empleado',
    //   // Filter: '',
    // },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div
        className="btn-group"
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
          <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
      </div>)
    }
  ];

  //Redux
  const dispatch = useDispatch();
  //EmerContact
  const loading = useSelector(store => store.jobStory.loading);
  const data = useSelector(store => store.jobStory.jobStory);
  const dataLenght = useSelector(store => store.jobStory.jobStoryLength);
  const saveJobStoryLoader = useSelector(store => store.jobStory.saveLoader);
 
  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    setValidated(false);
  }

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    setValidated(false);
  }

  useEffect(() => {
    dispatch(getJobStory({
      filter: props.match.params.id,
      empleado: props.match.params.id}, parseInt(props.match.params.type)));
  }, [dispatch, filter, props.match.params.id, props.match.params.type]);

  const onSubmit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const oData = {
      id: e.target.codigo.value,
      descripcion: e.target.descripcion.value,
			empleado: parseInt(props.match.params.id)
    }

    if(edit){
      dispatch(editJobStory(oData, editItem.id, index, parseInt(props.match.params.type)));
      setShowModal(false);
    }else{
      dispatch(saveJobStory(oData, parseInt(props.match.params.type)));
      e.target.reset();
      setShowModal(false);
    }

  }

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteJobStory(id, index, parseInt(props.match.params.type)));
    }
  }

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1">
            <h2 className="font-weight-bold d-flex justify-content-between align-items-center text-uppercase">{ props.match.params.name }
              <ButtonGroup>
                <Button
                  onClick={props.history.goBack}
                  size="sm"><i className="material-icons">keyboard_return</i></Button>
              <UserMenuComponent id={props.match.params.id} name={props.match.params.name} type={props.match.params.type} /> 
              <Button
                variant="primary"
                size="sm"
                onClick={() => onAdd()}><i className="material-icons">add</i></Button>
              </ButtonGroup>
            </h2>
            <hr />
            <h6>Historial laboral</h6>
          </div>
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center" />
              </div>
            ) : data.lenght > 0 ? (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={data} />
                  </Card.Body>
                </Card>
              </>
            ) : (
              <Alert variant="info" className="my-4">
                No tiene trabajos guardados.
              </Alert>
            )
          }
        </div>
      </div>
      <Modal
        show={showModal}
        size="lg"
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar historial laboral' : 'Crear historial laboral'}</Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <Row>
              <Form.Group as={Col} sm="12" md="12" lg="4" controlId="codigo">
                <Form.Label className="ml-2">Código</Form.Label>
                <Form.Control
                  name="codigo"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[0-9]+"
                  defaultValue={edit ? editItem.id : null}
                  placeholder="Código"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo se permiten números enteros
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="descripcion">
                <Form.Label className="ml-2">Descripción</Form.Label>
                <Form.Control
                  name="descripcion"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[a-zA-Z][a-zA-Z\s]*"
                  defaultValue={edit ? editItem.descripcion : null}
                  placeholder="Descripción de trabajo"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveJobStoryLoader}  
              variant="primary" 
              type="submit">
                {
                  saveJobStoryLoader ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default withRouter(JobStory)
